import { useLingui } from "@lingui/react/macro";
import { Container } from "@mui/material";
import AppLayout from "@/components/AppLayout";
import BackToBookingButton from "@/components/BackToBookingButton";
import MarkdownDocument from "@/components/MarkdownDocument";
import dePolicy from "./content/de.md?raw";
import enPolicy from "./content/en.md?raw";

export default function PrivacyPolicy() {
  const { i18n } = useLingui();
  const policy = i18n.locale === "de" ? dePolicy : enPolicy;

  return (
    <AppLayout contentMaxWidth="md">
      <Container maxWidth="md" sx={{ py: { xs: 3, sm: 4 }, px: { xs: 2, sm: 3 } }}>
        <BackToBookingButton />
        <MarkdownDocument>{policy}</MarkdownDocument>
      </Container>
    </AppLayout>
  );
}
